import Marquee from "react-fast-marquee";
import { Reveal } from "./Reveal";
import { useI18n } from "../i18n/LanguageContext";

const WORDS_EN = [
  "Cognitive Retrieval",
  "Semantic Reasoning",
  "Knowledge Graphs",
  "Intent Analysis",
  "Structured Answers",
];
const WORDS_IT = [
  "Recupero Cognitivo",
  "Ragionamento Semantico",
  "Knowledge Graph",
  "Analisi dell'Intento",
  "Risposte Strutturate",
];

export const BrandFamily = () => {
  const { t, lang } = useI18n();
  const words = lang === "it" ? WORDS_IT : WORDS_EN;
  return (
    <section className="relative py-24 md:py-32 border-y border-white/10 bg-[#0A1A2F]">
      <Reveal className="text-center px-6 mb-14">
        <p className="font-mono text-[13px] tracking-[0.3em] uppercase text-[#4BE3FF] mb-5">
          {t("brand.kicker")}
        </p>
        <h2 className="font-display font-bold tracking-tight text-3xl md:text-5xl">
          {t("brand.titleA")}{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#4BE3FF] to-[#1E6FFF]">
            Rexxpons
          </span>{" "}
          {t("brand.titleB")}
        </h2>
        <p className="font-ui text-[15px] text-[#A7B4C2] mt-5 max-w-xl mx-auto">
          {t("brand.desc")}
        </p>
      </Reveal>

      <Marquee speed={26} gradient gradientColor="#0A1A2F" gradientWidth={120}>
        {words.map((w) => (
          <div key={w} className="flex items-center">
            <span className="font-display font-bold uppercase text-4xl md:text-6xl tracking-tight text-white/10 mx-10 whitespace-nowrap">
              {w}
            </span>
            <span className="w-2.5 h-2.5 rounded-full bg-[#4BE3FF]/40" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
